import * as React from "react";

import { PlpDataSourceProductListControllerProvider } from "./plp-data-source-product-list-controller-provider";

export const PlpDataSourceProductListProvider: React.FunctionComponent = (
  props
) => {
  return (
    <PlpDataSourceProductListControllerProvider>
      {props?.children || []}
    </PlpDataSourceProductListControllerProvider>
  );
};
